import { Component, Input } from '@angular/core';
import * as i0 from "@angular/core";
export class RawComponent {
    renderer;
    elementRef;
    rendering;
    constructor(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
    }
    ngOnInit() {
        const el = this.renderer.createElement(this.rendering.name);
        const contents = this.renderer.createText(this.rendering.contents || '');
        const attributes = this.rendering.attributes;
        for (const attr in attributes) {
            // eslint-disable-next-line no-prototype-builtins
            if (attributes.hasOwnProperty(attr)) {
                const value = attributes[attr];
                this.renderer.setAttribute(el, attr, value || '');
            }
        }
        this.renderer.appendChild(el, contents);
        const parentNode = this.renderer.parentNode(this.elementRef.nativeElement);
        this.renderer.insertBefore(parentNode, el, this.elementRef.nativeElement);
        parentNode.removeChild(this.elementRef.nativeElement);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RawComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: RawComponent, selector: "sc-raw", inputs: { rendering: "rendering" }, ngImport: i0, template: '', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RawComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-raw',
                    template: '',
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { rendering: [{
                type: Input
            }] } });
